import { render } from "./designReferenceFormSelect.vue?vue&type=template&id=ad2e2e58"
import script from "./designReferenceFormSelect.vue?vue&type=script&lang=js"
export * from "./designReferenceFormSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__